<div class="modal-header">
    <h4 style="padding-right: 4px;" class="modal-title">{{title}}</h4>
    <button style="margin-right:4px;" type="button" class="close" aria-label="Close"
        (click)="dismiss()">
        <i style="font-size:16px;" class="fas fa-times"></i>
    </button>
</div>

<div class="modal-body">
    <div class="modal-body-inner">
        <h6 style="font-size:15px">
            {{message}}
        </h6>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="accept()">{{ btnOkText }}</button>
    <button type="button" class="btn btn-danger" (click)="decline()">{{ btnCancelText }}</button>
</div>